import Swal from "sweetalert2";
import { ApiService } from "./../../service/apiServices";
import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
} from "rxjs/operators";

@Component({
  selector: "app-imprimir-documentos",
  templateUrl: "./imprimir-documentos.component.html",
  styleUrls: ["./imprimir-documentos.component.css"],
})
export class ImprimirDocumentosComponent implements OnInit {
  filtro: FiltroBusca = {
    dataInicioBusca: null,
    dataFimBusca: null,
    cidadaoSelecionado: null,
  };
  pacienteSelecionado: any;
  listaCidadao: any = [];
  dataInicioBusca: any = null;
  dataFimBusca: any = null;
  documentos: any = [];
  carregando = false;
  buscaInput = new Subject<string>();

  constructor(public service: ApiService) {}

  ngOnInit() {
    this.buscaInput
      .pipe(
        debounceTime(2000), // espera 2 segundos após o usuário parar de digitar
        distinctUntilChanged(), // evita chamadas repetidas
        tap(() => (this.carregando = true)),
        switchMap((termo: string) => this.listarCidadao(termo))
      )
      .subscribe((resultados) => {
        this.listaCidadao = resultados;
        this.carregando = false;
      });
  }

  resultBuscaCidadao = (result) => {
    if (result != null) {
      this.listaCidadao = result["conteudo"];
    }
  };

  listarCidadao(termo: string): Promise<any[]> { 
    return new Promise((resolve) => {
      setTimeout(() => {
        this.service.Get(`Cidadao?Skip=1&Take=50&Busca=${termo}`).then(
          (result) => {
            this.resultBuscaCidadao(result);
            resolve(this.listaCidadao);
          },
          (error) => {
            console.error("Erro ao buscar cidadão:", error);
            resolve([]);
          }
        );
      }, 500);
    });
  }

  selecionarPaciente(item: any) {
    this.pacienteSelecionado = item;
  }

  pesquisar() {    

    if(!this.filtro.dataInicioBusca || !this.filtro.dataFimBusca){
      Swal.fire({
        title: "Atenção",
        text: "A data inicial e data final são obrigatórias",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    
    }


    var urlRequest = `DocumentoExterno?`;
    if (this.filtro.cidadaoSelecionado) {
      urlRequest += `cidadao_id=${this.filtro.cidadaoSelecionado.id}`;
    }
    if (this.filtro.dataInicioBusca) {
      urlRequest += `&data_inicio=${this.filtro.dataInicioBusca}`;
    }
    if (this.filtro.dataFimBusca) {
      urlRequest += `&data_fim=${this.filtro.dataFimBusca}`;
    }
    this.service.Get(urlRequest).then(
      (result) => {
        const documentosExternos: { tipo_documento: number }[] = result as {
          tipo_documento: number;
        }[];
        this.documentos = documentosExternos;
      },
      (error) => {
        Swal.fire("Error", error.error.messagem, "error");
      }
    );
  }

  limparBusca() {
    this.filtro = {
      dataInicioBusca: null,
      dataFimBusca: null,
      cidadaoSelecionado: null,
    };
    this.listaCidadao = [];
    this.documentos = []; 
  }
}
interface FiltroBusca {
  dataInicioBusca: Date | null;
  dataFimBusca: Date | null;
  cidadaoSelecionado: any | null;
}
